module.exports = __webpack_public_path__ + "static/img/zyzq.91121a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zyzq.png
// module id = anrS
// module chunks = 3